import {
  Box,
  Button,
  Center,
  Collapse,
  Divider,
  Heading,
  Stack,
  VStack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { ItemCard } from 'apps/TenantApp/components/ItemCard';
import { SuspendWithSpinner } from 'components/SuspendWithSpinner';
import { BullhornIcon, CloseIcon } from 'components/icons';
import React from 'react';
import { useState } from 'react';
import { RemirrorJSON } from 'remirror';
import { isEmptyMessage } from 'utils/editor';
import { lazy } from '@loadable/component';

const RichTextArea = lazy(() => import('components/Editor/RichTextArea'));

export type AddAnnouncementActionProps = {
  spaceId: string;
  linkIds: string[];
  onMessageChange(message?: RemirrorJSON): void;
};

export const AddAnnouncementAction = ({
  spaceId,
  linkIds,
  onMessageChange,
}: AddAnnouncementActionProps) => {
  const [shouldAddAnnouncement, setShouldAddAnnouncement] = useState(false);

  const messageChangeHandler = (stringifiedMessage?: string) => {
    const message = JSON.parse(stringifiedMessage || '');
    if (isEmptyMessage(message)) {
      onMessageChange(undefined);
    } else {
      onMessageChange(message);
    }
  };

  const onRemoveAnnouncement = () => {
    setShouldAddAnnouncement(false);
    onMessageChange(undefined);
  };

  return (
    <Box>
      <Collapse in={!shouldAddAnnouncement}>
        <Button
          w="100%"
          p={10}
          variant="ghost"
          colorScheme="blue"
          border="2px dashed"
          leftIcon={<BullhornIcon />}
          size="lg"
          onClick={() => setShouldAddAnnouncement(true)}
        >
          {t`Add announcement`}
        </Button>
      </Collapse>
      <Collapse in={shouldAddAnnouncement}>
        <Stack my={5} spacing={5}>
          <Stack spacing={8}>
            <Stack>
              <Heading margin="2px" fontSize="md">
                {t`Your note`}
              </Heading>
              <SuspendWithSpinner>
                <RichTextArea
                  placeholder={t`Text here`}
                  onChange={messageChangeHandler}
                  editable
                  spaceId={spaceId}
                />
              </SuspendWithSpinner>
            </Stack>
            <Stack>
              <Heading fontSize="md">{t`Links`}</Heading>
              <VStack alignItems="stretch">
                {linkIds.map((linkId) => (
                  <ItemCard key={linkId} itemId={linkId} />
                ))}
              </VStack>
            </Stack>
          </Stack>
          <Center>
            <Button
              variant="ghost"
              colorScheme="blue"
              size="sm"
              onClick={onRemoveAnnouncement}
              leftIcon={<CloseIcon />}
            >
              {t`Don't add announcement`}
            </Button>
          </Center>
          <Divider />
        </Stack>
      </Collapse>
    </Box>
  );
};
